import emptyIconProfile from "../images/emptyIconProfile.svg"
import phoneHeadset from "../images/phoneHeadset.svg"
import envelope from "../images/envelope.svg"
import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {Button, Image, Row} from "antd";
import {useNavigate, useParams} from "react-router-dom";
import {DiplomaCard} from "../Components/DiplomaCard";
import usePortalService from "../services/PortalService";
import { Tooltip } from 'antd';
import star from '../images/star.svg';
import emptyLike from '../images/emptyLike.svg';
import fillLike from '../images/fillLike.svg';
import { InviteCandidate } from "../Components/Modals/InviteCandidate";
import { ManagerNavbar } from "../Components/Navbars";
import { Diploma } from "../types";
import { LoaderWithTimer } from "../Components/LoaderWithTimer";

const Tag = styled.span`
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: center;
  color : #29A340;
  background-color: #EFFBF1;
  border: 1px solid #DEF7E3;
  border-radius: 2em;
  height : 60%;
  padding: 0 0.65em 0.45em 0.65em;
  margin-bottom: 1em;
`

const TextBlock = styled.p`
  line-height: 22px;
  white-space: pre-line;
  letter-spacing: 0em;
  font-size: 14px;
`

const HeaderText = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0;
  text-align: left;
  color: #222222;
  margin-bottom: 8px;
`

const CompanyName = styled(HeaderText)`
  font-size: 14px;
  margin-bottom: 2px;
`

const Footer = styled.footer`
  position: sticky;
  height: 72px;
  background: #FFFFFF;
  width: 100vw;
  max-width: 100%;
  padding: 16px 6vw 16px 6%;
  transition: box-shadow 200ms ease-in-out;

  @media only screen and (max-width: 700px) {
    width: calc(12% + 700px);
  }
  
  &.with-border {
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.1);
  }

  &.without-border {
    box-shadow: none;
  }
`

const EditButton = styled(Button)`
  padding: 8px 24px 8px 24px;
  border-radius: 4px;
  color : #45505A;
  border: 1px solid #A9B3BC;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  height: 100%;
  &:hover {
    border-color: #A9B3BC !important;
    color: #76838F !important;
  }
`

const RemoveButton = styled(Button)`
  padding: 8px 24px 8px 24px;
  border-radius: 4px;
  color : #F34921;
  border: 1px solid #F34921;
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  text-align: center;
  height: 100%;
  &:hover {
    border-color: #F37456 !important;
    color: #F37456 !important;
  }
`

const PublishButton = styled(Button)`
  &:hover {
    background-color: #56ADF3 !important;
  }
`

let profileId: string;
export const StudentAccauntForEmployer = () => {
  const {addInFavoriteProfiles, deleteFromFavoriteProfiles, profileMainInformationForManager, getAvatar} = usePortalService();

  const params = useParams();
  profileId = params.id as string;

  const navigate = useNavigate()

  const [isBottom, setIsBottom] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  const [fullName, setFullName] = useState('')
  const [status, setStatus] = useState()
  const [rating, setRating] = useState(0)
  const [address, setAddress] = useState()
  const [phone, setPhone] = useState()
  const [email, setEmail] = useState()
  const [educationLevel, setEducationLevel] = useState()
  const [institution, setInstitution] = useState()
  const [yearGraduation, setYearGraduation] = useState()
  const [specialtyName, setSpecialtyName] = useState()
  const [isTargetEducation, setIsTagetEducation] = useState()
  const [targetCompany, setTargetCompany] = useState()
  const [about, setAbout] = useState()
  const [avatar, setAvatar] = useState('');
  const [isAvatarLoad, setIsAvatarLoad] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);

  const [position, setPosition] = useState('')

  const [diplomas, setDiplomas] = useState<Diploma[]>([])

  const handleScroll = () => {
    const element = document.getElementById("main");
    element && setIsBottom(element.getBoundingClientRect().bottom - window.innerHeight <= 10)
  }

  const detectPosition = (yearGraduation: number) => {
    if (yearGraduation == 0) {
      return;
    }
    const now = new Date();
    const currentYear = now.getFullYear();
    const academicYearIsOver = (now.getMonth() > 5)
    if (currentYear > yearGraduation) {
      setPosition(`Выпускник ${yearGraduation} года.`)
    } else if (currentYear == yearGraduation) {
      if (academicYearIsOver) {
        setPosition("Выпускник этого года.")
      } else {
        setPosition("Студент, последний курс.")
      }
    } else {
      const course = 4 - (yearGraduation - currentYear) + (academicYearIsOver ? 1 : 0)
      setPosition(`Студент, ${course} курс.`)
    }

  }

  const favouriteHandle = async () => {
      if (isFavorite) {
          const result = await deleteFromFavoriteProfiles({
              profileId
          });

          if (result.success) {
            setIsFavorite(false)
          }
      } else {
          const result = await addInFavoriteProfiles({
              profileId
          });
  
          if (result.success) {
            setIsFavorite(true)
          }
      }
  };

  useEffect(() => {
    handleScroll()
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);

    (
      async () => {
        setIsLoading(true)
        profileMainInformationForManager(profileId).then(result => {
          if (result.success) {
            setFullName(result.profile.fullName)
            setStatus(result.profile.status)
            setRating(result.profile.rating)
            setAddress(result.profile.address)
            setPhone(result.profile.phoneNumber)
            setEmail(result.profile.email)
            setEducationLevel(result.profile.educationLevel)
            setInstitution(result.profile.educationalInstitution)
            setYearGraduation(result.profile.yearGraduation)
            setSpecialtyName(result.profile.specialtyName)
            setAbout(result.profile.aboutMe)
            setIsTagetEducation(result.profile.isTargetEducation)
            setTargetCompany(result.profile.targetCompany)
            if (result.profile.avatarId) {
              getAvatar(result.profile.avatarId)  
              .then(result => {
                  setAvatar(result)
                  setIsAvatarLoad(true)
              })
            } else {
                setAvatar(emptyIconProfile)
            }
            detectPosition(Number(result.profile.yearGraduation))
            setDiplomas(result.profile.certificates);
            setIsFavorite(result.profile.isFavorite);
          }
        }).catch(error => {
          console.log(error)
          setHasError(true)
        }).finally(() => {
          setIsLoading(false)
        })
      }
    )()
  },[])

  return(
    <div id="main">
      <ManagerNavbar />
      {(!isLoading && !hasError) ? 
        <div className="page700 d-flex flex-column gap-4">
          <div className='d-flex gap-3'>
            <Image src={avatar} preview={isAvatarLoad} style={{height : 112, objectFit : "cover", aspectRatio: "1/1", borderRadius : "0.5em"}}/>
            <div className="d-flex flex-column gap-1">
              <div className="header-card">
                <h1 style={{display:'inline-block', marginRight: '8px'}}>{fullName}</h1>
                {(status) && <div className="find-candidate-card"> {status} </div>}
              </div>
              <div className="row-container">
                  <img src={star} width="16px" style={{marginTop:'-5px'}}/>
                  <p className="hours-number" style={{ marginBottom: '4px' }}>
                      {rating}
                  </p>
                  <Tooltip placement='bottom'
                  title="Рейтинг РТСИМ - рейтинг, основанный на данных по использованию компьютерных тренажеров РТСИМ.Карьера.">
                      <h6 style={{ marginBottom: '4px' }}>
                          Рейтинг РТСИМ
                      </h6>
                  </Tooltip>
              </div>
              {
                !(position && (isTargetEducation && targetCompany || !isTargetEducation))
                  ? <TextBlock>Образование не заполнено</TextBlock>
                  : <TextBlock> {position} {isTargetEducation ? `Целевой (${targetCompany})` : null}</TextBlock>
              }
              {
                !(address)
                  ? <TextBlock>Адрес не заполнен</TextBlock>
                  : <TextBlock> {address} </TextBlock>
              }
            </div>
          </div>
          <div>
            <HeaderText>{educationLevel}</HeaderText>
            <TextBlock>
              {`${yearGraduation ? `${yearGraduation} год окончания` : 'Год окончания : не заполнено'}
              ${institution ?? 'Образовательное учреждение : не заполнено'}
              ${specialtyName ?? 'Название специальности : не заполнено'}`}
            </TextBlock>
          </div>
          <div>
            <HeaderText>Обо мне</HeaderText>
            <TextBlock>
              {(about) ? about : "Не заполнено"}
            </TextBlock>
          </div>
          <div>
            <HeaderText>Дипломы и сертификаты</HeaderText>
            {
              diplomas.length === 0
                ? <TextBlock>Не загружено</TextBlock>
                :
                <Row>
                  {diplomas.map(diploma =>
                    <DiplomaCard key={diploma.id} diploma={diploma} />
                  )}
                </Row>
            }
          </div>
        </div>
        : 
        <LoaderWithTimer isLoading={isLoading} skeletonStyle="candidatePage"/>
      }
      {hasError && <p>Произошла ошибка при загрузке. Пожалуйста, попробуйте обновить страницу.</p>}
      <Footer className={isBottom ? "without-border" : "with-border"}>
        <div className="different-edges-container" style={{maxWidth: '700px'}}>
          <div className="d-flex gap-3">
            <Button 
              type="primary" 
              style={{height:'32px', padding: '5px 16px', marginRight: '16px'}}
              onClick={() => setModalOpen(true)}>
                 Пригласить
            </Button>
          </div>
          <div className="right-edge" style={{paddingTop:'5px'}}>
              <p className="ant-btn-text" style={{cursor:'pointer', height:'22px'}} onClick={() => favouriteHandle()}>
                  {(isFavorite === true) && <div> <img src={fillLike} /> В избранном </div>}
                  {(isFavorite === false) && <div> <img src={emptyLike} /> Сохранить в избранное </div>}
              </p>
          </div>
        </div>
      </Footer>
      <InviteCandidate isOpen={modalOpen} close={() => setModalOpen(false)} profileId={Number(profileId)} />
    </div>
  )
}